module.exports = __webpack_public_path__ + "gm992021/img/jianghu-6.png?160811a3";